import { render } from "./AgeCardsGames.vue?vue&type=template&id=921c347a"
import script from "./AgeCardsGames.vue?vue&type=script&lang=js"
export * from "./AgeCardsGames.vue?vue&type=script&lang=js"

import "./AgeCardsGames.vue?vue&type=style&index=0&id=921c347a&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__